module.exports = __webpack_public_path__ + "static/media/daycare2.a0b5bd2d.jpg";